import React, { useState, useEffect } from 'react';
import {
  Routes,
  Route,
  useParams,
  useNavigate,
  useLocation,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Flex } from '@chakra-ui/react';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";
import WritingFormHeader from './components/WritingFormHeader/WritingFormHeader';

import BrainstormForm from './BrainstormForm';
import PlanningForm from './PlanningForm';
import DraftingForm from './DraftingForm';
import RevisingForm from './RevisingForm';
import EditingForm from './EditingForm';
import Assessment from './Assessment';

import { essay_schema } from './data/essay_schema';

const returnUrl = '/';
const urlSuffix = '?returnUrl=' + returnUrl;
const breadcrumbs = [
  'Brainstorming',
  'Planning',
  'Drafting',
  'Revising',
  'Editing',
  'Assessment',
];

const BreadcrumEnum = Object.freeze({
  brainstorm: 1,
  plan: 2,
  draft: 3,
  revision: 4,
  edition: 5,
  assessment: 6,
});

function WritingPracticePage() {
  // console.log('0000000000000000000 -- entering WritingPracticePage');
  const { info: user, isAuthenticated } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();
  // console.log('location: ', location);
  const { essayId } = useParams();
  // console.log('current user info: ', user);
  const [breadcrumbProg, setBreadcrumbProg] = useState(1);

  const parentPath = '/writing-practice/' + essayId;
  const breadcrumbPaths = [
    `${parentPath}/brainstorming`,
    `${parentPath}/planning`,
    `${parentPath}/drafting`,
    `${parentPath}/revising`,
    `${parentPath}/editing`,
    `${parentPath}/assessment`,
  ];

  const essayDetails = {
    ...essay_schema,
    ...JSON.parse(localStorage.getItem('essayExerciseDetails')),
  };

  useEffect(() => {
    const sessionId = localStorage.getItem('session_id');
    if (!isAuthenticated && !sessionId) {
      navigate(`/signin?returnUrl=${location.pathname}${location.search}`, {
        state: { from: location },
      });
    }
    if (essayDetails?.essayId == essayId) return;
    api
      .get(`${API_BASE}/api/essay-exercise/retrieve-data?exerciseId=${essayId}`)
      .then((res) => {
        // console.log(
        //   'retrieve data from writing practice page, res: =====',
        //   res
        // );
        if (res.status == 200) {
          if (res.data?.code == 200) {
            const newExerciseData = res.data?.data;
            localStorage.setItem(
              'essayExerciseDetails',
              JSON.stringify(newExerciseData)
            );
            if (location.pathname == parentPath) {
              let progress = res.data.data?.progress;
              // console.log(
              //   'render to the next page: ',
              //   breadcrumbPaths[progress]
              // );
              navigate(breadcrumbPaths[progress]);
            }
          } else if (res.data?.code == 401002) {
            navigate('/access-denied');
          }
        }
      })
      .catch(() =>
        console.log('failed to fetch essay exercise, id: ', essayId)
      );
  }, []);

  const getRoutePath = (breadcrumbProg) => breadcrumbPaths[breadcrumbProg - 1];
  const getFormId = (breadcrumbProg) => {
    const route = getRoutePath(breadcrumbProg);
    const pathSplit = route?.split('/');
    return pathSplit[pathSplit?.length - 1];
  };

  return (
    <Flex direction="column" height="100vh">
      <WritingFormHeader
        breadcrumbProg={breadcrumbProg}
        breadcrumbs={breadcrumbs}
        breadcrumbPaths={breadcrumbPaths}
      />
      <Routes>
        <Route
          path={`${parentPath}/brainstorming`}
          element={
            <BrainstormForm
              breadcrumbProg={BreadcrumEnum.brainstorm}
              setBreadcrumbProg={setBreadcrumbProg}
              nextPath={getRoutePath(BreadcrumEnum.brainstorm + 1) + urlSuffix}
              // returnUrl={returnUrl}
              isPlanActive={user?.isPlanActive}
            />
          }
        />
        <Route
          path={`${parentPath}/planning`}
          element={
            <PlanningForm
              breadcrumbProg={BreadcrumEnum.plan}
              setBreadcrumbProg={setBreadcrumbProg}
              nextPath={getRoutePath(BreadcrumEnum.plan + 1) + urlSuffix}
              returnUrl={getRoutePath(BreadcrumEnum.plan - 1) + urlSuffix}
              isPlanActive={user?.isPlanActive}
            />
          }
        />
        <Route
          path={`${parentPath}/drafting`}
          element={
            <DraftingForm
              breadcrumbProg={BreadcrumEnum.draft}
              setBreadcrumbProg={setBreadcrumbProg}
              nextPath={getRoutePath(BreadcrumEnum.draft + 1) + urlSuffix}
              returnUrl={getRoutePath(BreadcrumEnum.draft - 1) + urlSuffix}
              isPlanActive={user?.isPlanActive}
            />
          }
        />
        <Route
          path={`${parentPath}/revising`}
          element={
            <RevisingForm
              path={parentPath}
              formId={getFormId(BreadcrumEnum.revision)}
              breadcrumbProg={BreadcrumEnum.revision}
              setBreadcrumbProg={setBreadcrumbProg}
              nextPath={getRoutePath(BreadcrumEnum.revision + 1) + urlSuffix}
              returnUrl={getRoutePath(BreadcrumEnum.revision - 1) + urlSuffix}
              isPlanActive={user?.isPlanActive}
            />
          }
        />
        <Route
          path={`${parentPath}/editing`}
          element={
            <EditingForm
              path={parentPath}
              breadcrumbProg={BreadcrumEnum.edition}
              setBreadcrumbProg={setBreadcrumbProg}
              nextPath={getRoutePath(BreadcrumEnum.edition + 1) + urlSuffix}
              returnUrl={getRoutePath(BreadcrumEnum.edition - 1) + urlSuffix}
              isPlanActive={user?.isPlanActive}
            />
          }
        />
        <Route
          path={`${parentPath}/assessment`}
          element={
            <Assessment
              breadcrumbProg={BreadcrumEnum.assessment}
              setBreadcrumbProg={setBreadcrumbProg}
              returnUrl={getRoutePath(BreadcrumEnum.assessment - 1) + urlSuffix}
            />
          }
        />
      </Routes>
    </Flex>
  );
}

export default WritingPracticePage;
